import {
  useMediaQuery
} from '@material-ui/core';
import Axios from 'axios';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import Layout from 'containers/layouts/layout';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Environment from 'utils/environments';
import SuggestionActions from './components/SuggestionActions';
import WelcomeBanner from './components/WelcomeBanner';
import ValidityProductCards from './components/ValidityProductCards';

const ALL_STATUSES = ['EXPIRED', 'ON_DATE', 'VALID'];

function LabelHome() {
  const { id: paramsID } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const isDesktopScreen = useMediaQuery('(min-width: 1389px)');
  const [message, setMessage] = useState({ description: '', status: '' });

  const getData = async () => {
    setLoading(true);
    try {
      const environment = Environment(process.env.REACT_APP_ENV);
      const res = await Axios.get(
        `${environment.catalog}/printer/products/labels`,
        {
          params: { restaurantId: paramsID }
        }
      );

      const responseData = res?.data || [];

      const mergedData = ALL_STATUSES.map((status) => {
        const found = responseData.find((item) => item.labelStatus === status);
        return {
          labelStatus: status,
          total: found?.total || 0
        };
      });

      setData(mergedData);
    } catch (error) {
      setMessage(
        error?.response?.data || {
          description: 'Erro ao carregar dados',
          status: 'error'
        }
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [paramsID]);

  return (
    <Layout>
      {!isDesktopScreen && <SuggestionActions />}

      {isDesktopScreen && <WelcomeBanner />}

      <ValidityProductCards data={data} loading={loading} />

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />
    </Layout>
  );
}

export default LabelHome;
